import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "./Logo";
import { fmtPhone, NAV_LINKS, telHref } from "../data/site";
import { useStore } from "../context/StoreContext";
import { WaButton } from "./WaButton";

export const Footer = () => {
  const { contact, locations } = useStore();
  const navigate = useNavigate();
  return (
    <footer data-testid="footer" className="bg-[#120906] pb-8 pt-16 text-brand-cream/70">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed">
              Fresh flavours, delicious meals and a warm dining experience — at Lucky's Kitchen,
              every visit is made memorable.
            </p>
            <a
              data-testid="footer-email-link"
              href={`mailto:${contact.email}`}
              className="mt-4 inline-flex items-center gap-2 text-sm text-brand-gold transition-colors hover:text-brand-amber"
            >
              <Mail className="h-4 w-4" /> {contact.email}
            </a>
          </div>
          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.24em] text-brand-gold">
              Quick Links
            </h3>
            <ul className="mt-5 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => navigate(l.to)}
                    className="text-sm transition-colors hover:text-brand-gold"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.24em] text-brand-gold">
              Our Locations
            </h3>
            <div className="mt-5 space-y-5">
              {locations.map((loc, i) => (
                <div key={loc.label || i} data-testid={`footer-location-${i}`}>
                  <p className="text-sm font-semibold text-brand-cream">{loc.label}</p>
                  <p className="mt-1 text-xs leading-relaxed">{loc.address}</p>
                  <a
                    href={telHref(loc.phone)}
                    className="mt-1.5 inline-block text-xs font-semibold text-brand-gold transition-colors hover:text-brand-amber"
                    data-testid={`footer-call-${i}`}
                  >
                    Call: {fmtPhone(loc.phone)}
                  </a>
                </div>
              ))}
            </div>
            <WaButton
              testId="footer-whatsapp-button"
              label="WhatsApp Us"
              fallbackLabel="Call Us"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-semibold text-[#0b3d20] transition-transform duration-300 hover:scale-[1.05]"
            />
          </div>
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-brand-cream/10 pt-7 text-xs sm:flex-row">
          <p>© {new Date().getFullYear()} Lucky's Kitchen. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <button onClick={() => navigate("/terms-and-conditions")} className="transition-colors hover:text-brand-gold">Terms &amp; Conditions</button>
            <button onClick={() => navigate("/privacy-policy")} className="transition-colors hover:text-brand-gold">Privacy Policy</button>
          </div>
          <p data-testid="footer-coledra-solutions-credit" className="text-brand-gold/80">
            Website Designed by <a href="https://coledra.com" target="_blank" rel="noopener noreferrer" className="hover:text-brand-amber">
              Coledra
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
